export const borderRadius = {
  X4: '4px',
  X8: '8px',
} as const
